import { Link, T } from 'govwell-ui'
import { RecordFieldDisplayFragment } from 'types/graphql'

import { RecordTypeStatusDisplay } from 'src/components/RecordTypeStatus/RecordTypeStatusDisplay'
import { getUrlForRecord } from 'src/utils/records'

type Props = {
  record: RecordFieldDisplayFragment
}

/**
 * Renders a Record-typed field value as a link to the record. Pulls everything
 * needed off the already-loaded fragment so we never have to issue an
 * `@requireAuth` `recordById` query — that previously crashed the public
 * dashboard for anonymous viewers. `getUrlForRecord` routes anonymous users
 * to the public record page when they lack access.
 */
export const RecordFieldDisplay = ({ record }: Props) => {
  const label =
    record.stringified ?? `#${record.issuedIdentifier ?? record.identifier ?? ''}`.trim()
  return (
    <T.Body>
      <Link
        internalRoute={getUrlForRecord({
          currentUserHasAccess: !!record.currentUserHasAccess,
          isDraft: !!record.isDraft,
          organizationSlug: record.organization?.slug,
          recordUuid: record.uuid,
        })}
      >
        {label}{' '}
        {record.status && (
          <RecordTypeStatusDisplay status={record.status} isDraft={!!record.isDraft} />
        )}
      </Link>
    </T.Body>
  )
}
